

import { Component, OnInit, ViewChild  } from '@angular/core';
import { CommonFunctionService,UserPOSData } from '../../../../services/Common/common-function.service';
//import { ListColumn } from './../../../core/list/list-column.model';
//import { ItemCategoryComponent } from './../item-category/item-category.component';
//import { DatePipe } from '@angular/common';
//import { MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
//import { ItemServiceService } from '../../../services/setup/item-service.service';

import { DatatableComponent } from '@swimlane/ngx-datatable';
const _clone = (d) => JSON.parse(JSON.stringify(d));
import { DataService } from '../../../../services/data.service';
import { environment } from '../../../../../environments/environment';
import { OrderService } from 'src/app/POS/POSServices/Setup/order.service';


@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent implements OnInit {
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;
  InvoiceList: any[]; 
  PaidInvoicelist: any[]
  PendingInvoicelist: any[]
  tableHover = true;
  tableStriped = true;
  tableCondensed = true;
  tableBordered = true;
  resultsLength:any;
  rows = [];
  temp = [];

  AlldataSource;
  PaidInvoicedataSource;
  PendingInvoicedataSource;
  posId: any;

  constructor(private service: OrderService, private commonfunction: CommonFunctionService) { 
    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
this.posId= merchantdata.PosSubscriptionId;
    this.GetOrderSetupList((data) => {
      // cache our list
      this.temp = _clone(data);
      this.rows = _clone(data);;
  });
  }

  ngOnInit() {
  }

  GetOrderSetupList(cb) {
    const req = new XMLHttpRequest();
    
    req.open('GET',environment.GetOrderSetupListUrl+"?PosSubscriptionId="+this.posId);
   
    req.onload = () => {
        cb(JSON.parse(req.response));
    };

    req.send();
}

}





